import logo from "../assets/images/Techqilla logo white.webp";
import dot from "../assets/images/dot.webp";
import { Link, useLocation } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import PrimaryButton from "./common/PrimaryButton";
import arrow from "../assets/images/arrow.svg";
import { sendNewsLetterData } from "../service/service";
import { toast } from "react-toastify";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import logo2 from "../assets/images/companylogo.svg";

type Socials = {
  icon: JSX.Element;
  link: string;
};
interface SubOption {
  name: string;
  path: string;
}

interface Option {
  name: string;
  path: string;
  active?: boolean;
  suboptions?: SubOption[];
}

type LinkType = {
  name: string;
  path: string;
  active?: boolean;
  options?: Option[];
};

const links: LinkType[] = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "Who We Are",
    path: "/who-we-are",
  },
  {
    name: "Case Study",
    path: "/case-study",
  },
  {
    name: "Careers",
    path: "/careers",
  },
  {
    name: "Blog",
    path: "/blog",
  },
];

const WhatWeDo: Option[] = [
  {
    name: "Branding & Marketing",
    path: "",
    active: false,
    suboptions: [
      { name: "Personal Branding ", path: "/personal-branding" },
      { name: "SEO & Content Marketing", path: "/seo-content-marketing" },
      { name: "Social Media Marketing (SMM)", path: "/social-media-marketing" },
      { name: "Pay Per Click", path: "/pay-per-click" },
      { name: "Email & CRM Marketing", path: "/email-marketing" },
      {
        name: "Influencer & Affiliate Marketing",
        path: "/influencer-marketing",
      },
      {
        name: "Analytics  & Performance Tracking ",
        path: "/analytic-and-performance-tracking",
      },
    ],
  },
  {
    name: "IT Services",
    path: "",
    active: false,
    suboptions: [
      { name: "Website & Web App Development", path: "/web-app-development" },
      {
        name: "Software & SaaS Development",
        path: "/software-saas-development",
      },
      { name: "Mobile App Development", path: "/mobile-app-development" },
      { name: "Cloud & DevOps Solutions", path: "/cloud-devops-development" },
      {
        name: "Cybersecurity & Data Protection",
        path: "/cybersecurity-data-protection",
      },
      { name: "IT Support & Maintenance", path: "/it-support-maintenance" },
    ],
  },
  {
    name: "Designing",
    path: "",
    active: false,
    suboptions: [
      { name: "Branding & Identity", path: "/branding-and-label" },
      { name: "Graphic design", path: "/graphic-designing" },
      { name: "UI/UX Design", path: "/ui-ux-designing" },
      { name: "Print & Merchandise Design", path: "/print-and-merchandise" },
    ],
  },
  {
    name: "Content Writing & Copywriting",
    path: "",
    active: false,
    suboptions: [
      { name: "Website Content", path: "/website-content" },
      { name: "SEO Blog Writing", path: "/seo-blog-writing" },
      { name: "Ad Copy & Sales Funnels", path: "/ad-copy-and-sale-funnels" },
      { name: "Social Media Strategy", path: "/social-media-strategy" },
      { name: "Personal Branding Content", path: "/personal-branding-content" },
      {
        name: "Podcast Scripting & Editing",
        path: "/podcast-scripting-and-editing",
      },
    ],
  },
  {
    name: "Motion Graphics & Video editing",
    path: "",
    active: false,
    suboptions: [
      { name: "Animated Videos", path: "/animated-videos" },
      { name: "Social Media Videos", path: "/social-media-videos" },
      { name: "YouTube Video Editing", path: "/youtube-video-editing" },
      {
        name: "Corporate & Business Videos",
        path: "/corporate-and-business-video",
      },
      {
        name: "Podcast & Interview Editing",
        path: "/podcast-and-interview-editing",
      },
      {
        name: "Explainer & Tutorial Videos",
        path: "/explainer-tutorial-video",
      },
    ],
  },
];

const socials: Socials[] = [
  {
    icon: (
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="group"
      >
        <rect
          x="0.524414"
          width="40.1389"
          height="40"
          rx="20"
          fill="#282828"
          className="group-hover:fill-[#F20B97]"
        />
        <path
          d="M29.5938 20C29.5938 15.05 25.5437 11 20.5938 11C15.6437 11 11.5938 15.05 11.5938 20C11.5938 24.5 14.8562 28.2125 19.1312 28.8875V22.5875H16.8812V20H19.1312V17.975C19.1312 15.725 20.4813 14.4875 22.5063 14.4875C23.5188 14.4875 24.5312 14.7125 24.5312 14.7125V16.9625H23.4062C22.2812 16.9625 21.9438 17.6375 21.9438 18.3125V20H24.4187L23.9688 22.5875H21.8313V29C26.3313 28.325 29.5938 24.5 29.5938 20Z"
          fill="#505050"
          className="group-hover:fill-[#fff]"
        />
      </svg>
    ),
    link: "https://www.facebook.com/hellotechqilla/",
  },
  {
    icon: (
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="group"
      >
        <rect
          x="0.524414"
          width="40.1389"
          height="40"
          rx="20"
          fill="#282828"
          className="group-hover:fill-[#F20B97]"
        />
        <path
          d="M26.9306 26.3372H24.2636V22.1604C24.2636 21.1644 24.2458 19.8822 22.8764 19.8822C21.4873 19.8822 21.2748 20.9674 21.2748 22.0879V26.3369H18.6078V17.7477H21.1681V18.9215H21.204C21.4602 18.4834 21.8305 18.1229 22.2753 17.8786C22.7202 17.6343 23.223 17.5152 23.7302 17.534C26.4333 17.534 26.9317 19.3121 26.9317 21.6253L26.9306 26.3372ZM15.5985 16.5736C15.2924 16.5736 14.9931 16.4829 14.7386 16.3129C14.484 16.1429 14.2856 15.9012 14.1684 15.6184C14.0512 15.3356 14.0205 15.0244 14.0802 14.7241C14.1398 14.4239 14.2872 14.1481 14.5036 13.9316C14.72 13.7151 14.9958 13.5676 15.296 13.5078C15.5962 13.4481 15.9074 13.4787 16.1902 13.5958C16.4731 13.7129 16.7148 13.9112 16.8849 14.1657C17.055 14.4202 17.1459 14.7194 17.1459 15.0255C17.1459 15.2288 17.1059 15.4301 17.0282 15.6179C16.9505 15.8057 16.8365 15.9763 16.6928 16.1201C16.5491 16.2638 16.3785 16.3778 16.1907 16.4557C16.003 16.5335 15.8017 16.5735 15.5985 16.5736ZM16.932 26.3372H14.2622V17.7477H16.932V26.3372ZM28.2602 11.0012H12.922C12.5739 10.9973 12.2384 11.1317 11.9893 11.375C11.7403 11.6183 11.598 11.9505 11.5938 12.2987V27.7011C11.5979 28.0494 11.74 28.3818 11.9891 28.6254C12.2381 28.8689 12.5737 29.0036 12.922 28.9999H28.2602C28.6092 29.0043 28.9457 28.8699 29.1957 28.6264C29.4458 28.3829 29.5889 28.0501 29.5938 27.7011V12.2976C29.5888 11.9487 29.4455 11.6161 29.1955 11.3729C28.9454 11.1296 28.6091 10.9955 28.2602 11.0001"
          fill="#505050"
          className="group-hover:fill-[#fff]"
        />
      </svg>
    ),
    link: "https://in.linkedin.com/company/techqilla",
  },
  {
    icon: (
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="group"
      >
        <rect
          x="0.350586"
          width="40.1389"
          height="40"
          rx="20"
          fill="#282828"
          className="group-hover:fill-[#F20B97]"
        />
        <path
          d="M20.4235 9.58984C15.8311 9.58984 14.488 9.59433 14.2269 9.61483C13.2845 9.68898 12.6981 9.82944 12.0592 10.1305C11.5668 10.362 11.1785 10.6302 10.7952 11.0063C10.0973 11.6921 9.6743 12.5358 9.52118 13.5387C9.44673 14.0256 9.42507 14.1249 9.42067 16.6118C9.41898 17.4408 9.42067 18.5318 9.42067 19.9951C9.42067 24.3386 9.42575 25.6086 9.44775 25.8553C9.52389 26.7233 9.6677 27.2695 9.97226 27.8669C10.5543 29.0104 11.6659 29.8688 12.9755 30.1891C13.429 30.2996 13.9298 30.3605 14.5728 30.3893C14.8452 30.4005 17.6217 30.4085 20.4 30.4085C23.1782 30.4085 25.9565 30.4053 26.2221 30.3925C26.9666 30.3594 27.3989 30.3044 27.8769 30.1875C28.5262 30.0299 29.1314 29.74 29.6502 29.3381C30.1689 28.9361 30.5887 28.4319 30.8802 27.8604C31.1788 27.2775 31.3302 26.7105 31.3988 25.8878C31.4137 25.7084 31.4199 22.8485 31.4199 19.9924C31.4199 17.1358 31.4132 14.2812 31.3983 14.1018C31.3289 13.2658 31.1775 12.7036 30.8692 12.1094C30.6162 11.623 30.3354 11.2598 29.9276 10.8884C29.2 10.2305 28.31 9.83008 27.2493 9.6853C26.7355 9.61499 26.6331 9.59417 24.0038 9.58984H20.4235Z"
          fill="#505050"
          className="group-hover:fill-[#fff]"
        />
        <path
          d="M20.417 12.3125C18.2113 12.3125 17.9345 12.3216 17.0682 12.3589C16.2036 12.3964 15.6134 12.526 15.097 12.7161C14.5629 12.9124 14.1098 13.1751 13.6583 13.6026C13.2066 14.0299 12.9291 14.4588 12.721 14.9642C12.5196 15.4532 12.3826 16.012 12.3437 16.8301C12.3051 17.6501 12.2949 17.9122 12.2949 20.0001C12.2949 22.0879 12.3047 22.3491 12.344 23.1691C12.3838 23.9875 12.5206 24.5461 12.7213 25.0349C12.9289 25.5405 13.2064 25.9694 13.658 26.3967C14.1092 26.8244 14.5624 27.0877 15.0962 27.284C15.6129 27.4741 16.2032 27.6037 17.0677 27.6412C17.934 27.6785 18.2106 27.6876 20.4161 27.6876C22.622 27.6876 22.8979 27.6785 23.7642 27.6412C24.6288 27.6037 25.2197 27.4741 25.7364 27.284C26.2704 27.0877 26.7229 26.8244 27.1741 26.3967C27.6259 25.9694 27.9034 25.5405 28.1115 25.0351C28.3111 24.5461 28.4482 23.9873 28.4888 23.1693C28.5277 22.3492 28.5379 22.0879 28.5379 20.0001C28.5379 17.9122 28.5277 17.6502 28.4888 16.8302C28.4482 16.0118 28.3111 15.4532 28.1115 14.9644C27.9034 14.4588 27.6259 14.0299 27.1741 13.6026C26.7223 13.1749 26.2706 12.9123 25.7359 12.7161C25.2182 12.526 24.6277 12.3964 23.7631 12.3589C22.8968 12.3216 22.621 12.3125 20.4146 12.3125H20.417ZM19.6884 13.6979C19.9046 13.6975 20.1459 13.6979 20.417 13.6979C22.5854 13.6979 22.8424 13.7052 23.6988 13.7421C24.4906 13.7763 24.9204 13.9016 25.2067 14.0068C25.5857 14.1461 25.8559 14.3127 26.14 14.5818C26.4242 14.8508 26.6002 15.1071 26.7477 15.4658C26.8589 15.7365 26.9914 16.1433 27.0274 16.8928C27.0663 17.7032 27.0748 17.9467 27.0748 19.9983C27.0748 22.0499 27.0663 22.2934 27.0274 23.1037C26.9912 23.8533 26.8589 24.2601 26.7477 24.5308C26.6005 24.8895 26.4242 25.145 26.14 25.4139C25.8557 25.6829 25.5858 25.8495 25.2067 25.9888C24.9207 26.0945 24.4906 26.2195 23.6988 26.2537C22.8426 26.2906 22.5854 26.2986 20.417 26.2986C18.2484 26.2986 17.9913 26.2906 17.1352 26.2537C16.3433 26.2191 15.9136 26.0939 15.6271 25.9887C15.2481 25.8493 14.9774 25.6828 14.6931 25.4137C14.4089 25.1446 14.2329 24.889 14.0854 24.5301C13.9742 24.2594 13.8417 23.8526 13.8057 23.1031C13.7668 22.2927 13.759 22.0493 13.759 19.9964C13.759 17.9435 13.7668 17.7013 13.8057 16.8909C13.8419 16.1414 13.9742 15.7346 14.0854 15.4636C14.2326 15.1048 14.4089 14.8486 14.6931 14.5795C14.9774 14.3105 15.2481 14.1439 15.6271 14.0042C15.9134 13.8985 16.3433 13.7736 17.1352 13.7392C17.8844 13.7072 18.1748 13.6975 19.6884 13.6959V13.6979ZM24.7522 14.9743C24.5594 14.9743 24.371 15.0284 24.2107 15.1298C24.0504 15.2312 23.9255 15.3753 23.8518 15.5439C23.778 15.7125 23.7587 15.898 23.7964 16.0769C23.834 16.2559 23.9268 16.4202 24.0632 16.5492C24.1995 16.6782 24.3732 16.7661 24.5623 16.8016C24.7513 16.8372 24.9473 16.8189 25.1254 16.749C25.3035 16.6791 25.4557 16.5609 25.5627 16.4091C25.6697 16.2574 25.7268 16.079 25.7268 15.8965C25.7268 15.3872 25.2902 14.974 24.7522 14.974V14.9743ZM20.417 16.0522C18.1137 16.0522 16.2462 17.8198 16.2462 20.0001C16.2462 22.1803 18.1137 23.9471 20.417 23.9471C22.7203 23.9471 24.5872 22.1803 24.5872 20.0001C24.5872 17.8198 22.7203 16.0522 20.417 16.0522ZM20.417 17.4375C21.912 17.4375 23.1242 18.5847 23.1242 20.0001C23.1242 21.4152 21.912 22.5626 20.417 22.5626C18.9218 22.5626 17.7098 21.4152 17.7098 20.0001C17.7098 18.5847 18.9218 17.4375 20.417 17.4375Z"
          fill="#282828"
          className="group-hover:fill-[#F20B97]"
        />
      </svg>
    ),
    link: "https://www.instagram.com/techqilla_/",
  },
  {
    icon: (
      <svg
        width="41"
        height="41"
        viewBox="0 0 41 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="group"
      >
        <rect
          x="0.350586"
          y="0.585938"
          width="40.1389"
          height="40"
          rx="20"
          fill="#282828"
          className="group-hover:fill-[#F20B97]"
        />
        <path
          d="M30.9546 15.302C30.7012 14.3607 29.9591 13.6186 29.0178 13.3652C27.2982 12.8945 20.4199 12.8945 20.4199 12.8945C20.4199 12.8945 13.5415 12.8945 11.8219 13.3471C10.8988 13.6005 10.1386 14.3607 9.88514 15.302C9.43262 17.0215 9.43262 20.5874 9.43262 20.5874C9.43262 20.5874 9.43262 24.1714 9.88514 25.8729C10.1386 26.8141 10.8807 27.5563 11.8219 27.8097C13.5596 28.2803 20.4199 28.2803 20.4199 28.2803C20.4199 28.2803 27.2982 28.2803 29.0178 27.8278C29.9591 27.5744 30.7012 26.8322 30.9546 25.891C31.4071 24.1714 31.4071 20.6055 31.4071 20.6055C31.4071 20.6055 31.4252 17.0215 30.9546 15.302Z"
          fill="#505050"
          className="group-hover:fill-[#fff]"
        />
        <path
          d="M18.23 17.293V23.8817L23.9499 20.5873L18.23 17.293Z"
          fill="#282828"
          className="group-hover:fill-[#F20B97]"
        />
      </svg>
    ),
    link: "https://www.youtube.com/@TechQilla",
  },
  {
    icon: (
      <svg
        width="41"
        height="41"
        viewBox="0 0 41 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="group"
      >
        <rect
          x="0.350586"
          y="0.585938"
          width="40.1389"
          height="40"
          rx="20"
          fill="#282828"
          className="group-hover:fill-[#F20B97]"
        />
        <path
          d="M20.4162 12.0664C15.4405 12.0664 11.4199 15.8791 11.4199 20.582C11.4199 24.1914 13.7893 27.2753 17.1361 28.5158C17.0546 27.843 16.988 26.8057 17.1657 26.0698C17.3286 25.4039 18.2171 21.8365 18.2171 21.8365C18.2171 21.8365 17.9506 21.3249 17.9506 20.575C17.9506 19.3905 18.6762 18.5074 19.5795 18.5074C20.3496 18.5074 20.7198 19.0541 20.7198 19.7059C20.7198 20.4348 20.2311 21.5281 19.972 22.5444C19.7572 23.3925 20.4236 24.0863 21.3047 24.0863C22.9041 24.0863 24.1332 22.4883 24.1332 20.1895C24.1332 18.15 22.5857 16.7272 20.3718 16.7272C17.8099 16.7272 16.3068 18.5424 16.3068 20.4208C16.3068 21.1497 16.603 21.9346 16.9732 22.3622C17.0472 22.4463 17.0546 22.5234 17.0324 22.6075C16.9658 22.8738 16.8103 23.4555 16.7807 23.5747C16.7437 23.7289 16.6474 23.7639 16.4771 23.6868C15.3664 23.1822 14.6704 21.6263 14.6704 20.3787C14.6704 17.6944 16.7288 15.2273 20.6161 15.2273C23.7334 15.2273 26.162 17.3299 26.162 20.1474C26.162 23.0841 24.2073 25.446 21.4973 25.446C20.5865 25.446 19.7276 24.9974 19.4388 24.4648C19.4388 24.4648 18.9872 26.0908 18.8761 26.4903C18.6762 27.2332 18.1283 28.1584 17.7581 28.7261C18.6022 28.9714 19.4907 29.1045 20.4236 29.1045C25.392 29.1045 29.4199 25.2918 29.4199 20.589C29.4125 15.8791 25.3845 12.0664 20.4162 12.0664Z"
          fill="#505050"
          className="group-hover:fill-[#fff]"
        />
      </svg>
    ),
    link: "https://www.pinterest.com/techqilla/",
  },
];

const socialsLight: Socials[] = [
  {
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="group"
      >
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          fill="#F20B97"
          className="group-hover:fill-white"
        />
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="#F20B97"
        />
        <path
          d="M29 20C29 15.05 24.95 11 20 11C15.05 11 11 15.05 11 20C11 24.5 14.2625 28.2125 18.5375 28.8875V22.5875H16.2875V20H18.5375V17.975C18.5375 15.725 19.8875 14.4875 21.9125 14.4875C22.925 14.4875 23.9375 14.7125 23.9375 14.7125V16.9625H22.8125C21.6875 16.9625 21.35 17.6375 21.35 18.3125V20H23.825L23.375 22.5875H21.2375V29C25.7375 28.325 29 24.5 29 20Z"
          fill="white"
          className="group-hover:fill-[#F20B97]"
        />
      </svg>
    ),
    link: "https://www.facebook.com/hellotechqilla/",
  },
  {
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="group"
      >
        <rect
          width="40"
          height="40"
          rx="20"
          fill="#F20B97"
          className="group-hover:fill-white"
        />
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="#F20B97"
        />
        <path
          d="M26.3369 26.3372H23.6698V22.1604C23.6698 21.1644 23.652 19.8822 22.2827 19.8822C20.8936 19.8822 20.6811 20.9674 20.6811 22.0879V26.3369H18.014V17.7477H20.5744V18.9215H20.6102C20.8665 18.4834 21.2367 18.1229 21.6816 17.8786C22.1264 17.6343 22.6292 17.5152 23.1364 17.534C25.8396 17.534 26.338 19.3121 26.338 21.6253L26.3369 26.3372ZM15.0047 16.5736C14.6986 16.5736 14.3994 16.4829 14.1448 16.3129C13.8903 16.1429 13.6918 15.9012 13.5746 15.6184C13.4575 15.3356 13.4267 15.0244 13.4864 14.7241C13.5461 14.4239 13.6934 14.1481 13.9098 13.9316C14.1263 13.7151 14.402 13.5676 14.7022 13.5078C15.0024 13.4481 15.3136 13.4787 15.5965 13.5958C15.8793 13.7129 16.1211 13.9112 16.2912 14.1657C16.4613 14.4202 16.5521 14.7194 16.5522 15.0255C16.5522 15.2288 16.5122 15.4301 16.4345 15.6179C16.3567 15.8057 16.2427 15.9763 16.099 16.1201C15.9553 16.2638 15.7847 16.3778 15.597 16.4557C15.4092 16.5335 15.208 16.5735 15.0047 16.5736ZM16.3382 26.3372H13.6684V17.7477H16.3382V26.3372ZM27.6665 11.0012H12.3282C11.9801 10.9973 11.6447 11.1317 11.3956 11.375C11.1465 11.6183 11.0042 11.9505 11 12.2987V27.7011C11.0041 28.0494 11.1463 28.3818 11.3953 28.6254C11.6444 28.8689 11.9799 29.0036 12.3282 28.9999H27.6665C28.0155 29.0043 28.3519 28.8699 28.602 28.6264C28.852 28.3829 28.9952 28.0501 29 27.7011V12.2976C28.995 11.9487 28.8518 11.6161 28.6017 11.3729C28.3517 11.1296 28.0153 10.9955 27.6665 11.0001"
          fill="white"
          className="group-hover:fill-[#F20B97]"
        />
      </svg>
    ),
    link: "https://in.linkedin.com/company/techqilla",
  },
  {
    icon: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="group"
      >
        <rect
          width="40"
          height="40"
          rx="20"
          fill="#F20B97"
          className="group-hover:fill-white"
        />
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="#F20B97"
        />
        <path
          d="M20.0036 9C15.4112 9 14.0681 9.00474 13.807 9.0264C12.8646 9.10473 12.2781 9.25312 11.6392 9.57122C11.1469 9.81571 10.7586 10.0991 10.3753 10.4964C9.67738 11.2209 9.25438 12.1122 9.10126 13.1718C9.02681 13.6861 9.00515 13.791 9.00075 16.4184C8.99906 17.2941 9.00075 18.4467 9.00075 19.9927C9.00075 24.5814 9.00583 25.9231 9.02782 26.1837C9.10396 27.1007 9.24778 27.6777 9.55234 28.3088C10.1344 29.5169 11.246 30.4238 12.5556 30.7622C13.0091 30.879 13.5099 30.9432 14.1529 30.9737C14.4253 30.9855 17.2018 30.994 19.9801 30.994C22.7583 30.994 25.5366 30.9906 25.8022 30.9771C26.5467 30.9421 26.979 30.884 27.457 30.7605C28.1063 30.594 28.7115 30.2877 29.2302 29.8631C29.749 29.4385 30.1687 28.9057 30.4603 28.302C30.7589 27.6862 30.9103 27.0872 30.9789 26.218C30.9937 26.0285 31 23.0071 31 19.9898C31 16.972 30.9932 13.9562 30.9783 13.7667C30.909 12.8835 30.7575 12.2896 30.4493 11.6618C30.1963 11.148 29.9154 10.7642 29.5077 10.3719C28.7801 9.6768 27.8901 9.2538 26.8294 9.10084C26.3156 9.02656 26.2132 9.00457 23.5838 9H20.0036Z"
          fill="white"
          className="group-hover:fill-[#F20B97]"
        />
        <path
          d="M19.9971 11.875C17.7914 11.875 17.5146 11.8846 16.6483 11.9241C15.7837 11.9637 15.1935 12.1005 14.6771 12.3014C14.1429 12.5088 13.6898 12.7863 13.2384 13.2379C12.7866 13.6893 12.5092 14.1424 12.301 14.6764C12.0997 15.193 11.9626 15.7833 11.9237 16.6476C11.8852 17.5139 11.875 17.7909 11.875 19.9966C11.875 22.2022 11.8848 22.4782 11.9241 23.3445C11.9638 24.2091 12.1007 24.7993 12.3014 25.3157C12.509 25.8498 12.7865 26.3029 13.2381 26.7544C13.6893 27.2061 14.1424 27.4843 14.6763 27.6917C15.193 27.8926 15.7833 28.0294 16.6478 28.069C17.5141 28.1085 17.7907 28.1181 19.9962 28.1181C22.2021 28.1181 22.478 28.1085 23.3443 28.069C24.2089 28.0294 24.7998 27.8926 25.3165 27.6917C25.8505 27.4843 26.3029 27.2061 26.7542 26.7544C27.2059 26.3029 27.4834 25.8498 27.6915 25.3158C27.8912 24.7993 28.0283 24.2089 28.0689 23.3447C28.1078 22.4784 28.1179 22.2022 28.1179 19.9966C28.1179 17.7909 28.1078 17.5141 28.0689 16.6478C28.0283 15.7832 27.8912 15.193 27.6915 14.6766C27.4834 14.1424 27.2059 13.6893 26.7542 13.2379C26.3024 12.7861 25.8507 12.5087 25.316 12.3014C24.7982 12.1005 24.2077 11.9637 23.3431 11.9241C22.4768 11.8846 22.201 11.875 19.9947 11.875H19.9971ZM19.2685 13.3386C19.4847 13.3382 19.726 13.3386 19.9971 13.3386C22.1655 13.3386 22.4225 13.3464 23.2788 13.3853C24.0707 13.4215 24.5005 13.5538 24.7867 13.665C25.1657 13.8122 25.436 13.9881 25.72 14.2724C26.0043 14.5566 26.1803 14.8274 26.3278 15.2064C26.439 15.4923 26.5715 15.9221 26.6075 16.7139C26.6464 17.5701 26.6549 17.8273 26.6549 19.9947C26.6549 22.1621 26.6464 22.4193 26.6075 23.2755C26.5713 24.0673 26.439 24.4971 26.3278 24.783C26.1806 25.162 26.0043 25.4319 25.72 25.716C25.4358 26.0002 25.1659 26.1762 24.7867 26.3234C24.5008 26.4351 24.0707 26.5671 23.2788 26.6033C22.4227 26.6422 22.1655 26.6506 19.9971 26.6506C17.8284 26.6506 17.5714 26.6422 16.7153 26.6033C15.9234 26.5667 15.4937 26.4344 15.2072 26.3232C14.8282 26.176 14.5575 26.0001 14.2732 25.7158C13.989 25.4316 13.813 25.1615 13.6655 24.7823C13.5543 24.4964 13.4218 24.0666 13.3858 23.2748C13.3469 22.4186 13.3391 22.1615 13.3391 19.9927C13.3391 17.8239 13.3469 17.568 13.3858 16.7119C13.422 15.92 13.5543 15.4903 13.6655 15.204C13.8127 14.825 13.989 14.5543 14.2732 14.27C14.5575 13.9858 14.8282 13.8098 15.2072 13.6622C15.4935 13.5506 15.9234 13.4186 16.7153 13.3822C17.4645 13.3484 17.7548 13.3382 19.2685 13.3365V13.3386ZM24.3323 14.6871C24.1395 14.6871 23.9511 14.7443 23.7908 14.8514C23.6305 14.9585 23.5056 15.1107 23.4318 15.2888C23.3581 15.4669 23.3388 15.6629 23.3764 15.8519C23.4141 16.041 23.5069 16.2146 23.6433 16.3509C23.7796 16.4872 23.9533 16.58 24.1423 16.6176C24.3314 16.6551 24.5274 16.6358 24.7055 16.562C24.8835 16.4882 25.0357 16.3632 25.1428 16.2029C25.2498 16.0426 25.3069 15.8541 25.3069 15.6613C25.3069 15.1233 24.8703 14.6867 24.3323 14.6867V14.6871ZM19.9971 15.8258C17.6938 15.8258 15.8263 17.6932 15.8263 19.9966C15.8263 22.2999 17.6938 24.1665 19.9971 24.1665C22.3004 24.1665 24.1673 22.2999 24.1673 19.9966C24.1673 17.6932 22.3004 15.8258 19.9971 15.8258ZM19.9971 17.2894C21.4921 17.2894 22.7042 18.5013 22.7042 19.9966C22.7042 21.4916 21.4921 22.7037 19.9971 22.7037C18.5018 22.7037 17.2899 21.4916 17.2899 19.9966C17.2899 18.5013 18.5018 17.2894 19.9971 17.2894Z"
          fill="#F20B97"
          className="group-hover:fill-white"
        />
      </svg>
    ),
    link: "https://www.instagram.com/techqilla_/",
  },
  {
    icon: (
      <svg
        width="40"
        height="41"
        viewBox="0 0 40 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="group"
      >
        <rect
          y="0.585938"
          width="40"
          height="40"
          rx="20"
          fill="#F20B97"
          className="group-hover:fill-white"
        />
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="#F20B97"
        />
        <path
          d="M30.5347 15.302C30.2813 14.3607 29.5391 13.6186 28.5979 13.3652C26.8783 12.8945 20 12.8945 20 12.8945C20 12.8945 13.1216 12.8945 11.402 13.3471C10.4789 13.6005 9.71863 14.3607 9.46522 15.302C9.0127 17.0215 9.0127 20.5874 9.0127 20.5874C9.0127 20.5874 9.0127 24.1714 9.46522 25.8729C9.71863 26.8141 10.4608 27.5563 11.402 27.8097C13.1397 28.2803 20 28.2803 20 28.2803C20 28.2803 26.8783 28.2803 28.5979 27.8278C29.5391 27.5744 30.2813 26.8322 30.5347 25.891C30.9872 24.1714 30.9872 20.6055 30.9872 20.6055C30.9872 20.6055 31.0053 17.0215 30.5347 15.302Z"
          fill="white"
          className="group-hover:fill-[#F20B97]"
        />
        <path
          d="M17.8101 17.293V23.8817L23.5299 20.5873L17.8101 17.293Z"
          fill="#F20B97"
          className="group-hover:fill-white"
        />
      </svg>
    ),
    link: "https://www.youtube.com/@TechQilla",
  },
  {
    icon: (
      <svg
        width="40"
        height="41"
        viewBox="0 0 40 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="group"
      >
        <rect
          y="0.585938"
          width="40"
          height="40"
          rx="20"
          fill="#F20B97"
          className="group-hover:fill-white"
        />
        <rect
          x="0.5"
          y="0.5"
          width="39"
          height="39"
          rx="19.5"
          stroke="#F20B97"
        />
        <path
          d="M19.9963 11.5859C15.0206 11.5859 11 15.6139 11 20.5822C11 24.3955 13.3694 27.6534 16.7162 28.964C16.6347 28.2532 16.5681 27.1573 16.7458 26.3799C16.9087 25.6764 17.7972 21.9076 17.7972 21.9076C17.7972 21.9076 17.5306 21.3671 17.5306 20.5748C17.5306 19.3235 18.2563 18.3905 19.1596 18.3905C19.9297 18.3905 20.2999 18.9681 20.2999 19.6567C20.2999 20.4267 19.8112 21.5818 19.552 22.6555C19.3373 23.5514 20.0037 24.2844 20.8848 24.2844C22.4842 24.2844 23.7133 22.5962 23.7133 20.1676C23.7133 18.0129 22.1658 16.5098 19.9519 16.5098C17.39 16.5098 15.8869 18.4276 15.8869 20.4119C15.8869 21.182 16.1831 22.0113 16.5533 22.4629C16.6273 22.5518 16.6347 22.6332 16.6125 22.7221C16.5459 23.0035 16.3904 23.618 16.3608 23.7439C16.3237 23.9068 16.2275 23.9438 16.0572 23.8624C14.9465 23.3293 14.2505 21.6855 14.2505 20.3675C14.2505 17.5316 16.3089 14.9253 20.1962 14.9253C23.3135 14.9253 25.7421 17.1466 25.7421 20.1232C25.7421 23.2256 23.7873 25.7209 21.0773 25.7209C20.1666 25.7209 19.3077 25.247 19.0189 24.6843C19.0189 24.6843 18.5673 26.4021 18.4562 26.8241C18.2563 27.609 17.7084 28.5864 17.3381 29.1861C18.1822 29.4453 19.0708 29.5859 20.0037 29.5859C24.972 29.5859 29 25.558 29 20.5896C28.9926 15.6139 24.9646 11.5859 19.9963 11.5859Z"
          fill="white"
          className="group-hover:fill-[#F20B97]"
        />
      </svg>
    ),
    link: "https://www.pinterest.com/techqilla/",
  },
];

const SubscribeSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  firstName: Yup.string().required("Name is required"),
});

const Footer = () => {
  const [isPrivacyPage, setIsPrivacyPage] = useState(false);
  const location = useLocation();
  const dataContext = useContext(AuthContext);
  const handleSubmit = async (values: { email: string; firstName: string }) => {
    try {
      const res = await sendNewsLetterData({
        ...values,
        from: "news-letter",
      });

      if (!res.status) {
        toast.error("Failed to subscribe, please try again later.");
        return;
      }

      const resData = res.response?.data;
      if (resData.status) {
        toast.success(resData.message);
      } else {
        toast.error(resData.message);
      }
    } catch (error) {
      toast.error("Failed to subscribe, please try again later.");
    }
  };

  useEffect(() => {
    if (
      [
        "/privacy-policy",
        "/terms-of-services",
        "/cancellation-policy",
      ].includes(location.pathname)
    ) {
      setIsPrivacyPage(true);
    } else {
      setIsPrivacyPage(false);
    }
  }, [location.pathname]);

  if (!dataContext) return null;
  const { theme } = dataContext;

  const SelectedTheme = theme === "dark" ? socialsLight : socials;

  return (
    <>
      {isPrivacyPage ? null : (
        <>
          <section
            className={`${
              theme === "dark"
                ? "bg-white border-t"
                : "bg-black text-white border-t border-black"
            } w-full  flex justify-center items-center overflow-hidden transition-all duration-500 relative z-10`}
          >
            <div className="w-full mx-auto py-16 px-4 sm:px-6 lg:px-8 font-montserrat flex flex-col lg:flex-row gap-10 sm:justify-between max-w-screen-2xl ">
              <div className="sm:w-[40%]">
                <div className="mb-10 lg:mb-24 flex flex-col items-center sm:items-start">
                  {theme === "dark" ? (
                    <div className="w-[200px] h-[76px]">
                      <img src={logo2} alt="" className="w-full" />
                    </div>
                  ) : (
                    <div className="w-[200px] h-[76px]">
                      <img src={logo} alt="" className="w-full" />
                    </div>
                  )}

                  <p className="text-[#8F9FA3] lg:w-[60%] mb-3 text-center sm:text-left">
                    The first free end-to-end analytics service for the site,
                    designed to work with enterprises of various levels and
                    business segments.
                  </p>
                  <div className="flex items-center gap-4 mb-10">
                    <Link to="/who-we-are">
                      <p>More About Us</p>
                    </Link>

                    <img src={dot} alt="dot" className="size-[10px]" />
                  </div>
                </div>

                <div className="flex flex-col-reverse sm:flex-row gap-10 justify-between items-center sm:items-end">
                  <div className="flex gap-5 sm:grid grid-cols-2 sm:gap-2 w-fit">
                    {SelectedTheme.map((item, index) => (
                      <div
                        key={index}
                        className="inset-0 size-10 flex justify-center items-center rounded-full  relative z-10 hover:shadow-[0px_0px_20px_#f20b97]"
                      >
                        <Link
                          to={item.link}
                          target="_blank"
                          onClick={() => window.scrollTo(0, 0)}
                        >
                          {item.icon}
                        </Link>
                      </div>
                    ))}
                  </div>
                  <div className="relative z-10 flex flex-col">
                    <h3 className="text-xl font-medium mb-1 text-center sm:text-left">
                      Contact Us
                    </h3>
                    <a
                      href="tel:+919958656653"
                      className="text-lg text-[#8F9FA3] text-center sm:text-left"
                    >
                      +91-9958656653
                    </a>
                    <a
                      href="tel:+919220247251"
                      className="text-lg text-[#8F9FA3] text-center sm:text-left"
                    >
                      +91-9220247251
                    </a>
                    <a
                      href="mailto:hello@techqilla.com"
                      className="text-lg text-[#8F9FA3] text-center sm:text-left"
                    >
                      hello@techqilla.com
                    </a>
                  </div>
                  <div className="relative z-10">
                    <h3 className="text-xl font-medium mb-1 text-center sm:text-left">
                      Location
                    </h3>
                    <p className="text-lg text-[#8F9FA3] text-center sm:text-left">
                      A-86, Sector-4
                    </p>
                    <p className="text-lg text-[#8F9FA3] text-center sm:text-left">
                      Noida, UP, 201301
                    </p>
                  </div>
                </div>
              </div>
              <div className="sm:w-[60%] flex flex-col justify-between ">
                <div className="sm:flex justify-between">
                  <ul className="flex flex-col sm:flex-row gap-10 sm:gap-20 mb-4 lg:mb-0 sm:w-[60%]">
                    {/* {links.map((link, index) => (
                      <li key={index}>
                        {link.options && (
                          <div className="group relative py-2 lg:py-0 z-10">
                            <div className="flex items-center">
                              <span
                                className={`${
                                  theme === "dark"
                                    ? "hover:text-black"
                                    : "hover:text-white"
                                } xl:text-lg text-[#8F9FA3] cursor-pointer`}
                              >
                                {link.name}
                              </span>
                              <SlArrowDown className="ml-1" fontSize={10} />
                            </div>
                            <div className="z-40 absolute left-0 w-60 lg:-ml-12 -mt-1 origin-top-left bg-white divide-y divide-gray-100 rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition duration-300">
                              <div className="py-1">
                                {link.options.map((option, index) => (
                                  <Link
                                    to={option.path}
                                    key={index}
                                    className={`${
                                      theme === "dark"
                                        ? "hover:text-black"
                                        : "hover:bg-gray-100"
                                    } block px-4 py-2 text-sm text-gray-700 `}
                                    onClick={() => window.scrollTo(0, 0)}
                                  >
                                    {option.name}
                                  </Link>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}
                        {!link.options && (
                          <div className=" mt-2 sm:mt-0">
                            <Link
                              rel="noopener noreferrer"
                              to={link.path}
                              className={`${
                                theme === "dark"
                                  ? "hover:text-black"
                                  : "hover:text-white"
                              } xl:text-lg text-[#8F9FA3] bg-transparent z-10 `}
                              onClick={() => window.scrollTo(0, 0)}
                            >
                              {link.name}
                            </Link>
                          </div>
                        )}
                      </li>
                    ))} */}
                    <div className="">
                      <h4 className="font-gtAmerica font-medium mb-4 text-center sm:text-left">
                        Quick Links
                      </h4>
                      <ul className="flex flex-col">
                        {links.map((link, idx) => (
                          <Link
                            key={idx}
                            to={link.path}
                            className="font-gtAmerica text-[#8F9FA3] mb-2 text-center sm:text-left"
                            onClick={() =>
                              window.scrollTo({ top: 0, behavior: "smooth" })
                            }
                          >
                            {link.name}
                          </Link>
                        ))}
                      </ul>
                    </div>
                    <div className="">
                      <h4 className="font-gtAmerica font-medium mb-4 text-center sm:text-left">
                        What We Do
                      </h4>
                      <ul>
                        {WhatWeDo.map((item, idx) => (
                          <div key={idx} className="relative ">
                            <li className=" group font-gtAmerica text-[#8F9FA3] mb-2 cursor-pointer text-center sm:text-left">
                              {item.name}{" "}
                              <div className="sm:absolute hidden bg-[#232323] z-10 border-2 border-secondary px-6 py-2 rounded-[10px] group-hover:flex flex-col">
                                {item.suboptions?.map((item, idx) => (
                                  <Link
                                    key={idx}
                                    to={item.path}
                                    className="mb-2"
                                    onClick={() =>
                                      window.scrollTo({
                                        top: 0,
                                        behavior: "smooth",
                                      })
                                    }
                                  >
                                    {item.name}
                                  </Link>
                                ))}
                              </div>
                            </li>
                          </div>
                        ))}
                      </ul>
                    </div>
                  </ul>
                  <div className="w-full flex flex-col mb-4 lg:mb-0 z-0 sm:w-[40%]">
                    <h3 className="font-semibold text-lg text-center sm:text-left">
                      Subscribe to our Newsletter
                    </h3>
                    <Formik
                      initialValues={{ email: "", firstName: "" }}
                      validationSchema={SubscribeSchema}
                      onSubmit={(values, { setSubmitting }) => {
                        handleSubmit(values);
                        setSubmitting(false);
                        alert(`Thank you for subscribing, ${values.email}`);
                      }}
                    >
                      {({ isSubmitting }) => (
                        <Form className="flex flex-col items-center sm:items-start justify-center text-white w-full">
                          <div className="mb-8 w-full flex flex-col-reverse items-center  gap-4">
                            <div className="sm:w-full">
                              <Field
                                type="email"
                                name="email"
                                id="email"
                                placeholder="Enter your email"
                                className={`${
                                  theme === "dark"
                                    ? "border-black"
                                    : "border-white"
                                } block w-fit sm:w-full py-4 border-b bg-transparent focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm relative z-10 text-center sm:text-left`}
                              />
                              <ErrorMessage
                                name="email"
                                component="div"
                                className="text-red-500 text-sm mt-2"
                              />
                            </div>
                            <div className="sm:w-full">
                              <Field
                                type="text"
                                name="firstName"
                                id="firstName"
                                placeholder="Enter Your name"
                                className={`${
                                  theme === "dark"
                                    ? "border-black"
                                    : "border-white"
                                } block w-fit sm:w-full py-4 border-b bg-transparent focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm relative z-10 text-center sm:text-left`}
                              />
                              <ErrorMessage
                                name="firstName"
                                component="div"
                                className="text-red-500 text-sm mt-2"
                              />
                            </div>
                          </div>
                          <PrimaryButton
                            type="submit"
                            disabled={isSubmitting}
                            className={`${
                              theme === "dark"
                                ? "border  border-secondary bg-white !text-black hover:shadow-[0_0_10px_2px] hover:shadow-secondary inset-0 hover:!text-white hover:bg-secondary"
                                : "border  border-secondary bg-white !text-black hover:shadow-[0_0_10px_2px] hover:shadow-secondary inset-0 hover:!text-white hover:bg-secondary"
                            } relative z-10 transition-all duration-500 w-fit text-center`}
                          >
                            Subscribe
                          </PrimaryButton>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row justify-between sm:items-end ">
                  <p className="text-lg text-[#8F9FA3] text-center sm:text-left">
                    © 2025 — Copyright All Rights reserved
                  </p>
                  <div
                    className="bg-primary flex justify-center items-center p-2 size-14 rounded-full mb-10 !cursor-pointer mt-5 sm:mt-0"
                    onClick={() =>
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      })
                    }
                  >
                    <img src={arrow} alt="" className="rotate-[270deg]" />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div
            className={`${
              theme === "dark"
                ? "bg-white text-black pt-4 border-t"
                : "bg-black text-white"
            }  pb-10`}
          >
            <div className="max-w-screen-2xl mx-auto px-5 flex flex-col sm:flex-row items-center sm:items-start justify-between gap-2 py-4 sm:py-0">
              <Link
                to="/terms-of-services"
                className="font-montserrat opacity-50"
                target="_blank"
              >
                Terms of Services
              </Link>
              <Link
                to="/privacy-policy"
                className="font-montserrat opacity-50"
                target="_blank"
              >
                Privacy Policy
              </Link>
              <Link
                to="/cancellation-policy"
                className="font-montserrat opacity-50"
                target="_blank"
              >
                Cancellation & Refund Policy
              </Link>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Footer;
